import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Input from '../components/common/Input';
import { ForgotPasswordApi } from '../services/accountService';

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: ''
  });

  const [errors, setErrors] = useState({
    email: ''
  });

  const [touched, setTouched] = useState({
    email: false
  });

  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [apiError, setApiError] = useState('');

  // Email validation function (same as SignIn)
  const validateEmail = (email) => {
    if (!email || email.trim() === '') {
      return 'Email is required';
    }
    
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      return 'Please enter a valid email address';
    }
    return '';
  };

  // Real-time validation effect
  useEffect(() => {
    const validateField = (name, value) => {
      if (touched[name]) {
        if (name === 'email') {
          return validateEmail(value);
        }
      }
      return '';
    };

    const newErrors = {
      email: validateField('email', formData.email)
    };

    setErrors(newErrors);
  }, [formData, touched]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));

  
    if (apiError) {
      setApiError('');
    }

  
    if (!touched[name]) {
      setTouched(prevState => ({
        ...prevState,
        [name]: true
      }));
    }
  };

  const handleBlur = (e) => {
    const { name } = e.target;
  
    if (!touched[name]) {
      setTouched(prevState => ({
        ...prevState,
        [name]: true
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setApiError('');

  
    setTouched({
      email: true
    });

  
    const emailError = validateEmail(formData.email);
    
    if (emailError) {
      setErrors({
        email: emailError
      });
      return;
    }

    setIsLoading(true);

    try {
      
      
    
      const response = await ForgotPasswordApi(formData.email);
      
  
      
     
      setIsSubmitted(true);
      
     
      setTimeout(() => {
        navigate('/verifyOtp-forgot', { 
          state: { email: formData.email } 
        });
      }, 5000);
      
    } catch (error) {
      console.error('Forgot password failed:', error);
      
      // Handle API errors
      if (error.response) {
      
        const errorData = error.response.data;
      
        
       if (errorData.errors && errorData.errors.message && errorData.errors.message.length > 0) {
        
        setApiError(errorData.errors.message[0]);
      } else if (errorData.message) {
        
        setApiError(errorData.message);
      } else {
       
        switch (error.response.status) {
          case 400:
            setApiError('Invalid email format or missing email');
            break;
          case 404:
            setApiError('No account found with this email address');
            break;
          case 429:
            setApiError('Too many attempts. Please try again later');
            break;
          case 500:
            setApiError('Server error. Please try again later');
            break;
          default:
            setApiError('Something went wrong. Please try again');
        }
      }
      } else if (error.request) {
       
        setApiError('Network error. Please check your connection');
      } else {
       
        setApiError('An error occurred. Please try again');
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleBackToLogin = () => {
    navigate('/');
  };

  return (
    <div className="login-page">
   
      <div className="welcome-section">
        <div className="welcome-content">
          <h1 className="welcome-title">Welcome to OpenBook</h1>
         
        </div>
      </div>
      
   
      <div className="login-section">
        <div className="login-form-wrapper">
          <div className='rockwell_logo'>
            <img src='../../assets/Rockwell-Logo.jpg' alt='rockwell_logo' />
          </div>
          
          <div className="form-title-section">
            <h4 className="form-title">Recover password</h4>
            <p className="form-subtitle">
              {isSubmitted 
                ? 'OTP has been sent to your email.'
                : 'Enter your email to reset your password.'
              }
            </p>
          </div>

             {/* Display API error */}
              {apiError && (
                <div className="api-error-message">
                  <span className="error-text">{apiError}</span>
                </div>
              )}

          {!isSubmitted ? (
            <form onSubmit={handleSubmit} className="login-form">
              <Input
                  label={<span>Email <span style={{ color: 'red' }}>*</span></span>}
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                onBlur={handleBlur}
                required
                placeholder="Enter your email"
              
                disabled={isLoading}
                 
              />

           

              <div className="form-buttons">
                <button 
                  type="submit" 
                  className={`login-btn ${isLoading ? 'loading' : ''}`}
                  disabled={isLoading}
                >
                  {isLoading ? (
                    <>
                      <span className="spinner"></span>
                      Processing...
                    </>
                  ) : 'Continue'}
                </button>
                
                <span
                  type="button" 
                  className="back-btn-forgot"
                  onClick={handleBackToLogin}
                >
                  Remember your password? <span className='back-to-login'> Back to Login</span>
                </span>
              </div>
            </form>
          ) : (
            <div className="success-message">
              <div className="success-icon">
                <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#4CAF50" strokeWidth="2">
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                  <polyline points="22 4 12 14.01 9 11.01"></polyline>
                </svg>
              </div>
              <p className="success-text">
                Check your email for the OTP. You will be redirected to OTP verification.
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;